import { advancedFlowSchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod/v4";

export const getAdvancedFlowById = {
  name: "getAdvancedFlowById" as const,
  input: z.object({ flowId: z.string() }),
  output: z.object({ advancedFlow: advancedFlowSchema }),
};
